<template>
	<div class="guide-app">
		<div class="guide-app__head display-flex-center justify-content-between">
			<router-link to="/" class="book-viewer__back secondary-color-txt font-size-16">
                <i class="icon-close font-size-14 secondary-color-txt"></i> Thoát
            </router-link>
            <h1 class="margin-0 p-0 book-viewer__title font-size-18 secondary-color-txt font-sanpro-semibold">{{ guideData.title ? guideData.title : '' }}</h1>
            <span></span>
		</div>
		<div class="guide-app__body">
			<PreviewBookImg v-if="guideData && guideData.totalPage && guideData.fileName" :totalPage="guideData.totalPage" :fileName="guideData.fileName" :scale="1" />
			<p v-else class="font-size-20 text-center">Dữ liệu đang được cập nhật</p>
		</div>
	</div>
</template>

<script>
	import { getGuideApp } from '@/store/common/api'
	import PreviewBookImg from '@/components/content-files/PreviewBookImg.vue';

	export default {
		name: 'GuideApp',
		components: {
			PreviewBookImg
		},
		data () {
			return {
				guideData: {}
			}
		},
		created() {
			this.getInfoGuide()
		},
		methods: {
			getInfoGuide() {
				let self = this;
				getGuideApp().then(res => {
					if(res && res.data && !res.errors) {
						self.guideData = res.data;
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.guide-app {

		&__head {
			padding: 0 15px;
		    height: 45px;
		    background: #f1f1f1;
		}

		&__body {
			padding: 15px 0;
			height: calc(100vh - 45px);
		}
	}
</style>